import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { RaceSessionService, VbLxpMapComponent } from '@vbrick/vb-lxp-lib';

enum Tabs {
	MAP,
	DRIVER_LIST,
}

@Component({
	selector: 'app-map',
	imports: [VbLxpMapComponent, CommonModule],
	templateUrl: './map.html',
	styleUrl: './map.css',
})
export class MapComponent {
	private readonly raceSessionService = inject(RaceSessionService);

	tabs = Tabs;
	currentTab = signal(Tabs.DRIVER_LIST);
	selectedDrivers = signal([]);

	readonly drivers = this.raceSessionService.raceTeamsPosition;

	onDriverClick(driver: any) {
		if (this.selectedDrivers().includes(driver.number)) {
			this.selectedDrivers.update((sd) => sd.filter((d) => d !== driver.number));
		} else {
			this.selectedDrivers.update((sd) => [...sd, driver.number]);
		}
	}
}
